export const ReportMinYear: number = 2020;
export const ReportMaxYear: number = (new Date()).getFullYear();

